import React, { useCallback } from 'react'
import { FormControlLabel, Radio, RadioGroup } from '@mui/material'
import { BoundingBoxType } from '../../types'

interface BoundingBoxStepProps {
  boundingBoxType: BoundingBoxType
  setBoundingBoxType: (value: BoundingBoxType) => void
}

const BoundingBoxLabels = {
  [BoundingBoxType.None]: 'Do not generate',
  [BoundingBoxType.Auto]: 'Generate automatically',
}

const BoundingBoxStep: React.FC<BoundingBoxStepProps> = ({ boundingBoxType, setBoundingBoxType }) => {
  const handleChange = useCallback(
    (e: React.ChangeEvent<HTMLInputElement>) => setBoundingBoxType(Number(e.target.value)),
    [setBoundingBoxType]
  )
  return (
    <RadioGroup value={boundingBoxType} onChange={handleChange} name='boundingBoxType'>
      {Object.entries(BoundingBoxLabels).map(([key, label]) => (
        <FormControlLabel key={key} value={Number(key)} control={<Radio color='primary' />} label={label} />
      ))}
    </RadioGroup>
  )
}

export default BoundingBoxStep
